module.exports = function getResource (label, vars = []) {
    let resources = {
        confirmBasketUpdateModalTitle: 'Confirmation',
        confirmBasketUpdateModalButtonText: 'Continue',
        sureToContinueMessage: 'Are you sure you want to continue?'
    };
    return resources[label];
};
